/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const OfferIcon = ({ width = 24, height = 24, hidden = false, title = 'Offer' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m18.26 10.911 1.993 5.228 5.629.264a.233.233 0 0 1 .136.415l-4.4 3.5 1.489 5.382a.235.235 0 0 1-.356.256l-4.711-3.063-4.711 3.068a.235.235 0 0 1-.356-.256l1.486-5.391-4.4-3.5a.233.233 0 0 1 .141-.414l5.629-.264 1.993-5.228a.236.236 0 0 1 .438.003ZM2 28H0v2a2 2 0 0 0 2 2h4v-2H2ZM6 4h4v2H6zM8 30h4v2H8zM0 10h2v4H0zM2 6h2V4H2a2 2 0 0 0-2 2v2h2ZM0 16h2v4H0zM0 22h2v4H0zM34 10h2v4h-2zM34 16h2v4h-2zM34 22h2v4h-2zM14 30h4v2h-4zM12 4h4v2h-4zM34 4h-4v2h4v2h2V6a2 2 0 0 0-2-2ZM18 4h4v2h-4zM34 30h-2v2h2a2 2 0 0 0 2-2v-2h-2ZM26 30h4v2h-4zM20 30h4v2h-4zM24 4h4v2h-4z"
    />
  </svg>`;
};
